import React from "react";

const DocsCard = (props) => {
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  if (props?.data && Object.keys(props?.data).length > 0) {
    console.log(props?.data);
    var {
      pan_file_id,
      aadhar_front_file_id,
      aadhar_back_file_id,
      agreement_file_id,
    } = props?.data?.connector_documents[0] || {};
    var is_agreement_signed = props?.data?.is_agreement_signed;
  }
  const handleAgreement = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let payload = {
      profileId: props?.data?.profileId,
    };
    props.apis.apiSendAgreementForEsign(payload).then((res) => {
      console.log({ res });
    });
  };
  return (
    <div className="card profile_card">
      <div className="card-header border-0">
        <div className="d-flex align-items-center mb-3">
          <div className="img_outer">
            <img
              src={imagepaths.cardGaurdIcon}
              alt="cardGaurdIcon"
              className="card_icon"
            />
          </div>
          <h5 className="title ms-2 mb-0">Docs Details</h5>
        </div>
      </div>
      <div className="card-body">
        <div className="docs_card_container">
          <div className="">
            <div className="docs_card">
              <img src={imagepaths.pancardIcon} alt="pancardIcon" />
              <div className="content">
                <h2 className="title">PAN Card Front</h2>
                {pan_file_id ? (
                  <a href={`${BASE_URL}${pan_file_id}`}>Download</a>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
          <div className="">
            <div className="docs_card">
              <img src={imagepaths.aadharcardIcon} alt="aadharcardIcon" />
              <div className="content">
                <h2 className="title">Aadhar Card (Front)</h2>
                {aadhar_front_file_id ? (
                  <a href={`${BASE_URL}${aadhar_front_file_id}`}>Download</a>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
          <div className="">
            <div className="docs_card">
              <img src={imagepaths.aadharcardIcon} alt="aadharcardIcon" />
              <div className="content">
                <h2 className="title">Aadhar Card (Back)</h2>
                {aadhar_back_file_id ? (
                  <a href={`${BASE_URL}${aadhar_back_file_id}`}>Download</a>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
          <div className="">
            <div className="docs_card d-flex align-items-start ps-5">
              <img src={imagepaths.agreementcardIcon} alt="agreementcardIcon" />
              <div className="content">
                <h2 className="title">Agreement</h2>
                {is_agreement_signed ? (
                  <a href={`${BASE_URL}${agreement_file_id}`}>Download</a>
                ) : (
                  "-"
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="esign_box mt-4">
          <div className="d-flex align-items-center">
            {/* <i
              className={Object.className({
                "me-2": true,
                "fa-regular fa-circle-check text-green":
                  is_agreement_signed === true,
                "fa-regular fa-circle-xmark": is_agreement_signed === false,
              })}
            ></i>
            <p className="m-0">E-Signed Done</p> */}

            {is_agreement_signed === true && (
              <>
                <img src={imagepaths.greenCheckIcon} alt="icon" />
                <p className="m-0">E-Signed Done</p>
              </>
            )}
            {is_agreement_signed === false && (
              <>
                <img src={imagepaths.redCrossIcon} alt="icon" />
                <p className="m-0">E-Signed Not Done</p>
              </>
            )}
          </div>
          <button
            type="button"
            className={Object.className({
              "d-none": !isAdmin,
            })}
            onClick={(...args) => handleAgreement(...args)}
          >
            Re-Initiate
          </button>
        </div>
      </div>
    </div>
  );
};

export default constore(DocsCard);
